import axios from "axios";
import { GridColDef,GridPreProcessEditCellProps } from '@mui/x-data-grid';
import EmailInputCell from "components/EditableGrid/EmailInputCell";
import "i18n/config";
import i18next from "i18next";

export const get = async (row?:any) => {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+row.id_organization+"/department/"+row.id+"/user");
    return response.data;
};

export const getUsers = async (id_organization:any) => {
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+id_organization+"/user");
  return response.data;
};

export const update = async (row:any, masterRow?:any) => {
    let response = null;
    if(!row.id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id_organization+"/department/"+masterRow.id+"/user/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id_organization+"/department/"+masterRow.id+"/user/update/"+row.id,row);
    }
    return response.data;
};

export const destroy = async (id:any, masterRow?:any) => {
    let response = null;
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id_organization+"/department/"+masterRow.id+"/user/delete/"+id);
    return response.data;
};

export async function getColumns(locale: string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 90 
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      editable: true,
    },
    {
      field: 'email',
      headerName: i18next.t('Email'),
      flex: 1,
      type: 'email',
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError = params?.props.value?.indexOf('@') === -1 || params?.props.value?.indexOf('.') === -1;
        return { ...params.props, error: hasError, message:'Insert e valid email' };
      },
      renderEditCell: EmailInputCell,
      editable: true,
    }
  ] as GridColDef[]
};